import React, { Fragment } from 'react';
import { get } from 'lodash';
import moment from 'moment';
import styled from 'styled-components';
import { COLORS } from 'config/theme';
import config from 'config/config';

import IconPermIdentity from '@material-ui/icons/PermIdentity';
import IconAssessment from '@material-ui/icons/Assessment';
import IconShare from '@material-ui/icons/Share';
// import IconCheckCircle from '@material-ui/icons/CheckCircle';
// import avatarImg from 'images/console-users/user-avatar-1.svg';

import { InfoTitle } from '../../styles';

const StyledUserInfo = styled.div`
  width: 360px;
  min-width: 360px;
  padding-left: 18px;
  border-right: 1px solid ${COLORS.primaryLight};
  border-top: 1px solid ${COLORS.primaryLight};
  overflow-y: auto;
`;

const List = styled.ul`

`;

const Item = styled.li`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 48px;
  padding: 9px 0;

  border-bottom: 1px solid ${COLORS.primaryLight};
  color: ${COLORS.primaryColor};
  font-size: 16px;
  line-height: 1.6;

  svg {
    margin-right: 16px;
    width: 24px;
    color: ${COLORS.primaryLighter};
  }
`;

const NoData = styled.div`
  color: rgba(0,0,0,0.64);
`;

// const UserData = styled.div`
//   display: flex;
//   align-items: center;

//   ${List} {
//     width: 100%;
//   }

//   svg {
//     margin-left: auto;
//   }
// `;

// const Avatar = styled.img`
//   margin-right: 15px;
// `;

const UserInfo = ({ selectedUser }) => {
  const email = get(selectedUser, 'email', null);
  const last_updated = get(selectedUser, 'last_updated', null);

  return (
    <StyledUserInfo>
      <List>
        <Item>
          <InfoTitle>Email</InfoTitle>
          {!!email ? email : <NoData>Email not found</NoData>}
        </Item>
      </List>

      <List>
        <Item>
          <InfoTitle>Sources</InfoTitle>
          3/17 completed
        </Item>
      </List>

      <List>
        <Item>
          <InfoTitle>Last viewed</InfoTitle>
          {moment.utc(last_updated).format('YYYY-MM-DD HH:mm:ss')}
        </Item>
      </List>

      {!config.hideModalDetails && (
        <Fragment>
          <InfoTitle>
            Details
          </InfoTitle>

          <List>
            <Item>
              <IconPermIdentity />
              Owner: No owner
            </Item>

            <Item>
              <IconShare />
              Phone: Add
            </Item>

            <Item>
              <IconAssessment />
              Rating: Unknown: Add
            </Item>
          </List>
        </Fragment>
      )}
    </StyledUserInfo>
  );
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Details/UserInfo/UserInfo.js